import styled from 'styled-components/macro';
import RightColumn from 'styled/Page/RightColumn';

const RightColumnStyled = styled(RightColumn)`
  top: 60px;
  height: calc(100vh - 48px);
  margin-left: 32px;
  padding: 17px 0 24px;
`;

export default RightColumnStyled;
